import { FC } from 'react';
import { formatTimeRange } from 'shared/lib';

import { IDateCardProps } from '../models/types';

import styles from './styles.module.scss';

export const DateCard: FC<IDateCardProps> = ({
  dayNum,
  evenQuantity,
  oddQuantity,
  times,
}) => {
  const dayNums = [
    '',
    'Понедельник',
    'Вторник',
    'Среда',
    'Четверг',
    'Пятница',
    'Суббота',
  ];

  const formattedEvenTime = times.evenTime
    ? `${times.evenTime.start} — ${times.evenTime.end && formatTimeRange(times.evenTime.end)}`
    : null;

  const formattedOddTime = times.oddTime
    ? `${times.oddTime.start} — ${times.oddTime.end && formatTimeRange(times.oddTime.end)}`
    : null;

  return (
    <div className={styles['date-card']}>
      <div className={styles['date-card__section-1']}>
        <span className={styles['date-card__date']}>{dayNums[dayNum]}</span>
        <span className={styles['date-card__lessons-quantity']}>
          {' '}
          — {evenQuantity}({oddQuantity})
        </span>
      </div>

      <div className={styles['date-card__section-2']}>
        {formattedEvenTime && formattedOddTime && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <span className={styles['date-card__time-even']}>
              {formattedEvenTime}
            </span>
            <div
              style={{
                display: 'inline-block',
                width: '6px',
                height: '6px',
                backgroundColor: 'var(--gray-light-25)',
                borderRadius: '50px',
                margin: '0 5px',
              }}
            ></div>
            <span className={styles['date-card__time-odd']}>
              {formattedOddTime}
            </span>
          </div>
        )}
        {formattedEvenTime && !formattedOddTime && (
          <span className={styles['date-card__time-even']}>
            {formattedEvenTime}
          </span>
        )}
        {!formattedEvenTime && formattedOddTime && (
          <span className={styles['date-card__time-odd']}>
            {formattedOddTime}
          </span>
        )}
      </div>
    </div>
  );
};
